/*
 * Dorm Dash A2 — product page order fields.
 *
 * - "Let us curate it for you" is pre-selected; the toggle reveals native <select>s.
 * - Slots above the selected tier stay hidden AND disabled, so they are never submitted.
 * - Dawn puts novalidate on the product form, so required fields are validated here.
 * - The sticky bar mirrors the price straight out of Dawn's price block.
 */
(function () {
  'use strict';

  var TIER_WORDS = { classic: 1, signature: 2, deluxe: 3 };

  function rankFromText(text) {
    if (!text) return 0;
    var t = String(text).toLowerCase();
    for (var word in TIER_WORDS) {
      if (t.indexOf(word) !== -1) return TIER_WORDS[word];
    }
    return 0;
  }

  function Fields(root) {
    this.root = root;
    this.modeInputs = root.querySelectorAll('[data-dda2-mode]');
    this.flavorWrap = root.querySelector('[data-dda2-flavors]');
    this.slots = root.querySelectorAll('[data-dda2-slot]');
    this.counter = root.querySelector('[data-dda2-counter]');
    this.buildingSelect = root.querySelector('[data-dda2-building]');
    this.otherWrap = root.querySelector('[data-dda2-other-address]');
    this.errorBox = root.querySelector('[data-dda2-error]');
    this.form = root.closest('form');
    this.bind();
    this.syncMode();
    this.syncTier(parseInt(root.dataset.tierRank, 10) || 1);
    this.syncOtherAddress();
    this.bindAccordion();
  }

  Fields.prototype.bind = function () {
    var self = this;

    Array.prototype.forEach.call(this.modeInputs, function (input) {
      input.addEventListener('change', function () {
        self.syncMode();
      });
    });

    this.root.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-dda2-flavor')) self.updateCounter();
      if (e.target === self.buildingSelect) self.syncOtherAddress();
      if (e.target.hasAttribute('data-dda2-required')) self.clearFieldError(e.target);
    });

    this.root.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-dda2-required')) self.clearFieldError(e.target);
    });
  };

  Fields.prototype.isChoosing = function () {
    var chosen = this.root.querySelector('[data-dda2-mode="choose"]');
    return !!(chosen && chosen.checked);
  };

  Fields.prototype.syncMode = function () {
    var choosing = this.isChoosing();
    if (this.flavorWrap) this.flavorWrap.hidden = !choosing;
    this.applySlotState();
    this.updateCounter();
  };

  Fields.prototype.syncTier = function (rank) {
    this.tierRank = rank || 1;
    this.root.dataset.tierRank = String(this.tierRank);
    this.applySlotState();
    this.updateCounter();
  };

  // A slot is live only when the buyer is choosing AND the slot belongs to this tier.
  Fields.prototype.applySlotState = function () {
    var choosing = this.isChoosing();
    var rank = this.tierRank || 1;
    Array.prototype.forEach.call(this.slots, function (slot) {
      var min = parseInt(slot.dataset.minTier, 10) || 1;
      var inTier = min <= rank;
      slot.hidden = !inTier;
      var select = slot.querySelector('select');
      if (select) select.disabled = !inTier || !choosing;
    });
  };

  Fields.prototype.activeFlavorSelects = function () {
    return Array.prototype.filter.call(
      this.root.querySelectorAll('[data-dda2-flavor]'),
      function (s) {
        return !s.disabled;
      }
    );
  };

  Fields.prototype.updateCounter = function () {
    if (!this.counter) return;
    var active = this.activeFlavorSelects();
    var chosen = active.filter(function (s) {
      return s.value !== '';
    }).length;
    this.counter.textContent = chosen + ' of ' + active.length + ' chosen';
  };

  Fields.prototype.syncOtherAddress = function () {
    if (!this.otherWrap || !this.buildingSelect) return;
    var isOther = this.buildingSelect.value === 'Other address in the delivery area';
    this.otherWrap.hidden = !isOther;
    var input = this.otherWrap.querySelector('input');
    if (input) {
      input.disabled = !isOther;
      if (!isOther) input.value = '';
    }
  };

  Fields.prototype.clearFieldError = function (el) {
    el.classList.remove('dda2-invalid');
    if (this.errorBox && !this.root.querySelector('.dda2-invalid')) {
      this.errorBox.hidden = true;
    }
  };

  /* A requested delivery date is a free date input, so the rules Julie works to have to be
     enforced here: enough notice, and never a Michigan home football Saturday. */
  Fields.prototype.checkRequestedDate = function () {
    var input = this.root.querySelector('[data-dda2-date-request]');
    if (!input || input.disabled || !input.value) return null;

    var blackouts = (input.getAttribute('data-dda2-blackouts') || '')
      .split(',')
      .map(function (d) { return d.trim(); })
      .filter(Boolean);

    if (blackouts.indexOf(input.value) !== -1) {
      return { field: input, message: "Julie does not deliver on that date, it is a Michigan home game day. Please pick another." };
    }

    /* The lead time is tested against data-dda2-lead-date, NOT against min. min is
       today, so the browser only ever rejects a date in the past. Anything sooner than
       the lead date is caught here instead, where the message is visible on the page and
       gets scrolled to, rather than by a native constraint that refuses to submit behind
       a bubble nobody sees. See the comment on the request-mode input in
       snippets/dda2-order-fields.liquid. */
    var lead = input.getAttribute('data-dda2-lead-date');
    if (lead && input.value < lead) {
      var days = input.getAttribute('data-dda2-lead-days') || '7';
      return { field: input, message: 'Please pick a date at least ' + days + ' days away, so Julie has time to put the box together.' };
    }
    return null;
  };

  // Returns the first invalid field, or null.
  Fields.prototype.findInvalid = function () {
    var required = this.root.querySelectorAll('[data-dda2-required]');
    var first = null;
    Array.prototype.forEach.call(required, function (el) {
      if (el.disabled || el.closest('[hidden]')) {
        el.classList.remove('dda2-invalid');
        return;
      }
      if (String(el.value || '').trim() === '') {
        el.classList.add('dda2-invalid');
        if (!first) first = el;
      } else {
        el.classList.remove('dda2-invalid');
      }
    });
    return first;
  };

  /* ---------- accordion summaries ---------- */

  // Short human summary of what each panel currently holds, shown on the collapsed header.
  Fields.prototype.summaryFor = function (key) {
    var val = function (sel) {
      var el = this.root.querySelector(sel);
      return el && !el.disabled ? String(el.value || '').trim() : '';
    }.bind(this);

    if (key === 'flavors') {
      if (!this.isChoosing()) return { text: 'Let us curate it for you', done: true };
      var active = this.activeFlavorSelects();
      var chosen = active.filter(function (s) { return s.value !== ''; }).length;
      return { text: chosen + ' of ' + active.length + ' chosen', done: true };
    }
    if (key === 'date') {
      var d = val('[name="properties[Delivery Date]"]');
      return { text: d || 'Choose a date', done: !!d };
    }
    if (key === 'where') {
      var b = val('[name="properties[Building]"]');
      var r = val('[name="properties[Room / Apt Number]"]');
      var a = val('[name="properties[Delivery Address]"]');
      var place = b === 'Other address in the delivery area' ? a : b;
      var parts = [place, r].filter(Boolean);
      return { text: parts.length ? parts.join(', ') : 'Building and room', done: !!(place && r) };
    }
    if (key === 'student') {
      var n = val('[name="properties[Student Name]"]');
      var p = val('[name="properties[Student Phone]"]');
      var m = val('[name="properties[Gift Message]"]');
      return { text: n || 'Name, phone and your message', done: !!(n && p && m) };
    }
    return { text: '', done: false };
  };

  Fields.prototype.updateSummaries = function () {
    var self = this;
    this.root.querySelectorAll('[data-dda2-acc]').forEach(function (acc) {
      var info = self.summaryFor(acc.dataset.dda2AccKey);
      var out = acc.querySelector('[data-dda2-acc-value]');
      if (out) out.textContent = info.text;
      acc.classList.toggle('dda2-acc--done', info.done);
    });
  };

  // Opening one panel closes the others, so only one block of fields is ever on screen.
  Fields.prototype.bindAccordion = function () {
    var self = this;
    var accs = this.root.querySelectorAll('[data-dda2-acc]');
    accs.forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        accs.forEach(function (other) {
          if (other !== acc) other.open = false;
        });
      });
    });
    this.root.addEventListener('change', function () { self.updateSummaries(); });
    this.root.addEventListener('input', function () { self.updateSummaries(); });
    this.updateSummaries();
  };

  Fields.prototype.revealField = function (el) {
    var acc = el.closest('[data-dda2-acc]');
    if (acc && !acc.open) acc.open = true;
  };

  Fields.prototype.validate = function () {
    var first = this.findInvalid();
    var message = null;

    if (!first) {
      var dateProblem = this.checkRequestedDate();
      if (!dateProblem) {
        if (this.errorBox) this.errorBox.hidden = true;
        return true;
      }
      first = dateProblem.field;
      first.classList.add('dda2-invalid');
      message = dateProblem.message;
    }

    this.revealField(first);
    var label = first.getAttribute('data-dda2-label') || 'this field';
    if (this.errorBox) {
      this.errorBox.textContent = message || 'Please add the ' + label + ' before adding to the cart.';
      this.errorBox.hidden = false;
    }
    try {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      first.scrollIntoView();
    }
    first.focus({ preventScroll: true });
    return false;
  };

  var instances = [];

  function init() {
    document.querySelectorAll('[data-dda2-fields]').forEach(function (root) {
      if (root.dataset.dda2Ready) return;
      root.dataset.dda2Ready = '1';
      instances.push(new Fields(root));
    });
    initSticky();
  }

  // A page can hold more than one field group on the same form. The gift card add-on has
  // both the shared delivery fields and its own business picker, so every group belonging
  // to the submitted form has to be validated, not just the first one found.
  function instancesForForm(form) {
    return instances.filter(function (inst) {
      return inst.form === form;
    });
  }

  /* Tidy what actually reaches the order, so Julie reads signal not blanks:
       - a flavour left on "Choose one..." posts "Curator's choice" rather than an empty row
       - an untouched optional field (allergies) posts nothing at all, so when that row
         DOES appear on an order it always means the buyer told us something */
  Fields.prototype.prepareForSubmit = function () {
    var temp = [];
    var form = this.form;

    this.activeFlavorSelects().forEach(function (sel) {
      if (sel.value !== '') return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = sel.name;
      hidden.value = "Curator's choice";
      form.appendChild(hidden);
      sel.disabled = true;
      temp.push({ hidden: hidden, select: sel });
    });

    var optional = this.root.querySelectorAll(
      '.dda2-input:not([data-dda2-required]), .dda2-select:not([data-dda2-required])'
    );
    Array.prototype.forEach.call(optional, function (el) {
      if (el.disabled || String(el.value || '').trim() !== '') return;
      el.disabled = true;
      temp.push({ select: el });
    });

    // Put everything back once the form data has been read.
    setTimeout(function () {
      temp.forEach(function (t) {
        if (t.hidden && t.hidden.parentNode) t.hidden.parentNode.removeChild(t.hidden);
        if (t.select) t.select.disabled = false;
      });
    }, 0);
  };

  // Capture phase on document runs before Dawn's own submit handler on the form.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var matching = instancesForForm(form);
      if (!matching.length) return;

      var firstInvalid = null;
      matching.forEach(function (inst) {
        var bad = inst.findInvalid() || (inst.checkRequestedDate() || {}).field;
        if (bad && !firstInvalid) firstInvalid = { inst: inst, field: bad };
      });

      if (firstInvalid) {
        firstInvalid.inst.validate();
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      matching.forEach(function (inst) {
        inst.prepareForSubmit();
      });
    },
    true
  );

  // Tier changes come from Dawn's variant picker.
  document.addEventListener('change', function (e) {
    var picker = e.target.closest && e.target.closest('variant-selects');
    if (!picker) return;
    var rank = rankFromText(e.target.value);
    if (!rank) return;
    // NB: <variant-selects> carries data-section itself, so closest('[data-section]')
    // returns the picker and never contains the fields. Scope to product-info instead.
    var scope = picker.closest('product-info');
    instances.forEach(function (inst) {
      if (!scope || scope.contains(inst.root)) inst.syncTier(rank);
    });
  });

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-dda2-sticky]');
    if (!bar || bar.dataset.dda2Ready) return;
    bar.dataset.dda2Ready = '1';

    // Dawn's scroll animations put a transform on an ancestor section, and a transformed
    // ancestor becomes the containing block for position:fixed. That anchored this bar to
    // the product column instead of the viewport. Reparenting to <body> avoids it entirely.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var priceOut = bar.querySelector('[data-dda2-sticky-price]');
    var sectionId = bar.dataset.sectionId;
    var priceBlock = document.getElementById('price-' + sectionId);

    function syncPrice() {
      if (!priceBlock || !priceOut) return;
      var el =
        priceBlock.querySelector('.price-item--sale') ||
        priceBlock.querySelector('.price-item--regular');
      if (el && el.textContent.trim()) priceOut.textContent = el.textContent.trim();
    }
    syncPrice();

    if (priceBlock && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceBlock, { childList: true, subtree: true });
    }

    // Show the bar only once the real Add to cart button has scrolled out of view.
    var anchor = document.getElementById('ProductSubmitButton-' + sectionId);
    if (anchor && window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('dda2-sticky--visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(anchor);
    } else {
      bar.classList.add('dda2-sticky--visible');
    }
  }

  /* ---------- clamp the maker stories ----------
     The description is the longest thing on the page (over 2000px). The storytelling is
     the product, so it stays, but it starts collapsed behind a Read more toggle. */
  function initDescriptionClamp() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.dda2Clamped) return;
    if (desc.getBoundingClientRect().height < 700) return;
    desc.dataset.dda2Clamped = '1';

    var wrap = document.createElement('div');
    wrap.className = 'dda2-clamp';
    desc.parentNode.insertBefore(wrap, desc);
    wrap.appendChild(desc);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button dda2-clamp__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read the full story';
    wrap.appendChild(btn);

    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('dda2-clamp--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read the full story';
      if (!open) wrap.scrollIntoView({ block: 'nearest' });
    });
  }

  function boot() {
    init();
    initDescriptionClamp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
